import React, { useState } from "react";
import "./ActionDialog.scss";
import { CircularProgress, Dialog } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { userAction } from "../../../redux/features/userSlice";
import { AuthApi } from "../../../utils/api/Auth";
import toast from "react-hot-toast";
import { CommonEnums } from "../../../enums/common.enums";
import { useNavigate } from "react-router-dom";
import { clientRoutes } from "../../../utils/routes";
import { subscriptionAction } from "../../../redux/features/subscriptionSlice";
import { designTemplateAction } from "../../../redux/features/designTemplateSlice";
import { templateAction } from "../../../redux/features/templateSlice";
import { agentAction } from "../../../redux/features/agentSlice";
import { agencyAction } from "../../../redux/features/agencySlice";

const ActionDialog = () => {
  const [state, setState] = useState({
    isLoading: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dialogBoxData = useSelector(
    (state: RootState) => state?.user?.actionDialogBoxData
  );

  const onClose = () => {
    if (!state?.isLoading) {
      dispatch(
        userAction.setActionDialogBoxData({
          id: "",
          action: "",
          api_key: "",
          name: "",
          type: "",
        })
      );
    }
  };
  const onClickDone = async () => {
    setState({
      ...state,
      isLoading: true,
    });

    let url_update = dialogBoxData.action;
    if (dialogBoxData.action === CommonEnums.userStatus.disabled) {
      url_update = "disable";
    }

    let res: any;

    if (dialogBoxData.action === "delete") {
      res = await AuthApi.deleleAll(
        `admin/${dialogBoxData?.api_key}/${url_update}/${dialogBoxData?.id}`
      );
    } else {
      res = await AuthApi.statusChange(
        `admin/${dialogBoxData?.api_key}/${url_update}/${dialogBoxData?.id}`
      );
    }

    if (res?.data?.success) {
      if (dialogBoxData.action === "delete") {
        toast.success(`Delete ${dialogBoxData.type} successfully.`);
      } else {
        toast.success("Status update successfully.");
      }

      dispatch(
        userAction.setActionDialogBoxData({
          id: "",
          action: "",
          api_key: "",
          name: "",
          type: "",
        })
      );

      switch (dialogBoxData?.type) {
        case CommonEnums.pageType?.User:
          dispatch(userAction.setUsersListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes.users);
          }
          break;

        case CommonEnums.pageType?.Subscription:
          dispatch(subscriptionAction.setSubscriptionListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes.subscriptions);
          }

          break;
        case CommonEnums.pageType?.design_templates:
          dispatch(designTemplateAction.setTemplateTypesListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes.designTemplates);
          }
          break;

        case CommonEnums.pageType?.templates_type:
          dispatch(templateAction.setTemplateTypesListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes.designTemplateTypes);
          }
          break;

        case CommonEnums.pageType?.agents:
          dispatch(agentAction.setAgentListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes?.agents);
          }
          break;

        case CommonEnums.pageType?.agencies:
          dispatch(agencyAction.setListReset());
          if (dialogBoxData.action === "delete") {
            navigate(clientRoutes?.agencies);
          }
          break;
      }
    } else {
      toast.error(
        res?.data?.message || res?.error || "Internal server error !"
      );
    }

    setState({
      ...state,
      isLoading: false,
    });
  };
  return (
    <div className="action-dialog-container">
      <Dialog
        maxWidth="sm"
        disablePortal
        open={dialogBoxData?.id ? true : false}
        onClose={onClose}
      >
        <div className="principal-agent-modal">
          <div className="new-action-dialog-body-contain">
            <p>{`Are you sure to ${dialogBoxData?.action} ${dialogBoxData?.name} ?`}</p>
          </div>
          <div className="principal-agent-dialog-btn">
            <button className="cancel-btn" onClick={onClose} type="reset">
              Cancel
            </button>
            <button className="switch-btn" onClick={onClickDone} type="reset">
              {state?.isLoading ? (
                <CircularProgress className="dialog-btn-circular-progress" />
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ActionDialog;
